import FmdGoodIcon from '@mui/icons-material/FmdGood'
import NearMeIcon from '@mui/icons-material/NearMe'
import classNames from 'classnames'
import { TSuggest } from 'feature/registration/types'
import { InformationBlock } from 'widget/InformationBlock/InformationBlock'

import style from './NeareatServiceCenter.module.scss'

type NeareatServiceCenterProps = {
  pageType: string
  address: TSuggest
}

// блок ближайшего СЦ на детальной странице СЦ
export function NeareatServiceCenter({
  pageType,
  address,
}: NeareatServiceCenterProps) {
  return (
    <div className={style.informationBlock}>
      <InformationBlock
        title={
          pageType === 'geo-address' ? 'ваш адрес (по геопозиции)' : 'ваш адрес'
        }
      >
        <span>
          {pageType === 'geo-address' && <NearMeIcon color='primary' />}
          {pageType === 'user-address' && <FmdGoodIcon color='primary' />}

          {address.address}
        </span>
      </InformationBlock>
      <div className={style.line} />
      <span className={classNames(style.title, 'h3')}>
        Ближайший Сервисный центр
      </span>
    </div>
  )
}
